import React from "react";
import "./NavItem.css";
import BaseLoaderComponent, {
  IBaseLoaderComponentProps
} from "../BaseLoaderComponent/BaseLoaderComponent";
import { Link } from "react-router-dom";

interface INavItemProps extends IBaseLoaderComponentProps {
  label: string;
}

export const NavItemPure = (props: INavItemProps) =>
  <React.Fragment>
    <Link
      className="link"
      to={`/${props.label.toLowerCase()}/`}>{props.label}</Link>
  </React.Fragment>;

export default BaseLoaderComponent(NavItemPure);
